<template>
    <b-col>
        <b-row>
            <h3 class="ml-3">EAN Abspalten</h3>
        </b-row>
        <b-row class="my-2">
            <b-col>
                <b-form-input v-model="eanSplitJob.ean" placeholder="EAN die abgespaltet werden soll"></b-form-input>
            </b-col>
            <b-col>
                <b-form-input v-model="eanSplitJob.asin" placeholder="neue ASIN"></b-form-input>
            </b-col>
            <b-col class="col-1 ml-0 pl-0">
                <b-col/>
                <b-col class="p-0">
                    <b-button 
                        block
                        size="md"
                        @click="submit()"
                        :disabled="requestProcessing"
                        variant="primary"
                    ><!-- button -->
                        <b-spinner v-if="requestProcessing" small  label="Spinning"/>
                        <span v-else class="icon icon-loop"/>
                    </b-button>
                </b-col>
                <b-col/>
            </b-col>
        </b-row>
        <b-row v-if="requestProcessing">
            <b-col><b class="float-right"> Ean-Split-Job wird erzeugt...</b></b-col>
        </b-row>
        <b-row  class="my-2 py-2">
            <b-table
                v-if="eanSplitJobs"
                :items="eanSplitJobs"
                :fields="fields"
            >
                <!-- template v-slot:cell(actions)="data">
                    <b-button size="md" @click="openInNewTab(`material/${data.item.materialDonorId}/edit`)" class="float-right">
                        <span class="icon icon-newspaper"></span>
                    </b-button>
                </template -->
                <template v-slot:cell(materialDonorId)="row">
                    <b-button size="sm" @click="openInNewTab(`material/${row.item.materialDonorId}/edit`)">
                        <!-- b style="font-family:'Lucida Console', monospace">{{row.item.asin}}</b -->
                        <span class="icon icon-newspaper"></span>
                    </b-button>
                </template>
                <template v-slot:cell(materialRecipientId)="row">
                    <b-button 
                        v-if="row.item.materialRecipientId"
                        size="sm"
                        :disabled="row.item.finishedAt"
                        @click="openInNewTab(`material/${row.item.materialRecipientId}/edit`)" 
                    >
                        <!-- b style="font-family:'Lucida Console', monospace">{{row.item.asin}}</b -->
                        <span class="icon icon-newspaper"></span>
                    </b-button>
                </template>
                <template v-slot:cell(userId)="row">
                    <span>{{users.find( user => user.id == row.item.userId ).name}}</span>
                </template>
            </b-table>
        </b-row>
        <b-modal v-model="modalError.state" size="md" centered dismissible>{{modalError.message}}</b-modal>
    </b-col>
</template>
<script>
  export default
  {
        data() {
            return {
               eanSplitJob: {
                   ean: null,
                   asin: null,
                   materialDonorId: null,
                   materialRecipientId: null
               },
               modalError: {
                   state: false,
                   message: ""
               },
               fields: [
                   { key: 'ean', label: 'EAN' },
                   { key: 'asin', label: 'neue ASIN' },
                   { key: 'created_at', label: 'erstellt am',       formatter: function(s) { return (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '‒' } },
                   { key: 'finished_at', label: 'abgeschlossen am', formatter: function(s) { return (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '‒' } },
                   { key: 'materialDonorId', label: 'alter Artikel' },
                   { key: 'materialRecipientId',label: 'neuer Artikel' },
                   { key: 'userId', label: 'Benutzer', formatter: (userId) => this.users.find( user => user.id == userId ).name },
                   { key: 'actions', label: '' }
               ],
               eanSplitJobs: null,
               requestProcessing: false,
               users: []
            }
        },
        methods: {
            submit() {
                this.requestProcessing = true;
                axios.post('/eansplitjob/create', this.eanSplitJob).then( response => {
                    this.requestProcessing = false;
                    //console.log(response); //fuck whoever knows why, but axios, laravel or me is fucking up the data for this specific route
                    this.getSplitJobs();
                }).catch( error => {
                    this.requestProcessing = false;
                    console.error(error);
                    this.modalError = {
                        state: true,
                        message: "Netzwerkfehler. Error: " + JSON.stringify(error.response.data.message)
                    }
                });
            },
            openInNewTab(url) {
                var win = window.open(url, "_blank");
                win.focus();
            },            
            getSplitJobs() {
                Promise.all([
                    axios.get('/eansplitjob/getamount/100'),
                    axios.get('/eansplitjob/getopen')
                ]).then( ([responseAmount, responseOpen]) => {
                    this.eanSplitJobs = responseAmount.data;
                    for(const x of responseOpen.data) {
                        if(!this.eanSplitJobs.find(y => x.id == y.id)){
                            this.eanSplitJobs.push(x);
                        }
                    }
                });
            }
        },
        created() {
           axios.get('/user/get').then( response => this.users = response.data );
           this.getSplitJobs();
        }
    }



/*
select zusatz asins from the ean table where more than 1 zusatzean is related to a single material.
    ```
        select * from (
        select count(*) as eanCount, ean.* from ean
        group by materialId
        limit 1000) stuff
        where eanCount > 1;
    ```
*/
</script>